import { gql } from '@apollo/client';


export const GET_ARRESTS = gql`
  query GET_ARRESTS($incidentId: ID!, $originatorId: ID!){
    getArrests(incidentId: $incidentId, originatorId: $originatorId) {
      id
      sealed
      incident {
        id
        uuid
      }
      arrestee {
        id
        personalAttribute {
          id
          firstName
          lastName
        }
      }
      arrestor {
        id
        deptAttribute {
          id
          badge
          stateIdNumber
          ori {
            id
            oriName
            abbreviation
          }
        }
        personalAttribute {
          id
          firstName
          lastName
        }
      }
      arrestedAt
      ibrMultipleArrestType {
        id
        name
      }
      location {
        city
        id
        lat
        lng
        name
        state
        streetName
        streetNumber
        unit
        zip
      }
      citedAt
      arresteeWeaponTypes {
        id
        name
      }
      ibrArrestType {
        id
        name
      }
      ibrClearanceCode {
        id
        name
      }
      arrestCharges {
        id
        nibrsSelected
        sealed
        offenseViolationPrototype {
          id
           maxPenalty
           minPenalty
           fullName
           name
           offenseCategory {
             id
             name
             oriId
             position
           }
           offenseSubCategory {
             id
             name
             oriId
             position
           }
           oriId
           points
           waiver
           yoe
        }
      }
      exceptionClearedAt
      ibrJuvenileDisposition {
        id
        name
      }
      childUnderEighteen
      printsPhotosNeeded
    }
  }
`;

